import { render } from "./Allocation.vue?vue&type=template&id=5cb66660"
import script from "./Allocation.vue?vue&type=script&lang=js"
export * from "./Allocation.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/budget/Allocation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5cb66660"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5cb66660', __exports__)) {
    api.reload('5cb66660', __exports__)
  }
  
  module.hot.accept("./Allocation.vue?vue&type=template&id=5cb66660", () => {
    api.rerender('5cb66660', render)
  })

}


export default __exports__